import React from 'react';
import styles from '../index.module.scss';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl } from '@mui/material';
import Select from '../../../../../../../Inputs/Select';
import { MOBILITY_AID_OPTIONS } from '../../../../../../../../Pages/PatientDetailsPages/ClinicalRecord/clinicalRecordOptions';
import classNames from 'classnames';
import { ReactComponent as ExpandMoreIcon } from '../../../../../../../../assets/icons/patientProfileIcons/expandMoreIcon.svg';
import useIntakeBlockToggle, {
  intakeBlocksEnum,
} from '../../../../hooks/useIntakeBlockToggle';

const AssistiveDeviceField = () => {
  const { control } = useFormContext();
  const { isOn, isRequired } = useIntakeBlockToggle();

  if (!isOn(intakeBlocksEnum.physical)) {
    return null;
  }

  return (
    <FormControl
      className={classNames(
        styles.inputWrapper,
        styles.selectWrapper,
        styles.largeInputWrapper
      )}
      required={isRequired(intakeBlocksEnum.physical)}>
      <Controller
        name="assistiveDevice"
        control={control}
        defaultValue={''}
        render={({ field }) => (
          <Select
            options={MOBILITY_AID_OPTIONS.filter(item=>item.isIntake)}
            label="Assistive device"
            {...field}
            IconComponent={ExpandMoreIcon}
            classes={{
              select: styles.inputField,
              icon: styles.selectIcon,
            }}
            className={styles.selectRoot}
            disableUnderline
            displayEmpty={true}
            renderValue={(value) => (
              <div
                className={classNames(styles.selectValue, {
                  [styles.placeholder]: !value,
                })}>
                {value
                  ? MOBILITY_AID_OPTIONS?.find(
                      (option) => option?.value === value
                    )?.label
                  : 'Select device'}
              </div>
            )}
          />
        )}
        rules={{
          required: {
            value: isRequired(intakeBlocksEnum.physical) ?? false,
            message: 'Assistive device is required',
          },
        }}
      />
    </FormControl>
  );
};

export default AssistiveDeviceField;
